import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useMediaQuery } from "react-responsive";

const ProjectCard = (props) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const [title, setTitle] = useState(props.title);
  const [imageUrl, setImageUrl] = useState(props.imageUrl);
  const [content, setContent] = useState(props.content);
  const [stack, setStack] = useState(props.stack);
  const [sourceCode, setSourceCode] = useState(props.sourceCode);

  useEffect(() => {
    setStack(props.stack);
    setTitle(props.title);
    setImageUrl(props.imageUrl);
    setContent(props.content);
    setSourceCode(props.sourceCode);
  }, []);

  return (
    <Card
      style={{
        border: "1px solid #E0E0E0",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        width: isTabletOrMobile? "100%": "300px",
        marginTop: "20px",
        boxShadow: "6px 2px 15px #E0E0E0",
        borderRadius: "12px",
      }}
    >
      <div>
        <CardMedia
          component="img"
          height="150px"
          image={imageUrl}
          alt="project image"
        />
        <CardContent>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            style={{ fontFamily: "Tenorite", fontWeight: "600" }}
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            style={{ fontFamily: "Tenorite", fontSize: "15px" }}
          >
            {content}
          </Typography>
          <div
            style={{
              display: "flex",
              marginTop: "15px",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            {stack.map((itm) => (
              <div
                style={{
                  marginRight: "10px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={itm.icon} width="25px" height="25px" />
                <Typography
                  variant="caption"
                  color="text.secondary"
                  style={{ fontFamily: "Tenorite" }}
                >
                  {itm.name}
                </Typography>
              </div>
            ))}
          </div>
        </CardContent>
      </div>
      <div>
        <CardActions>
          <Button
            disabled={sourceCode == "" ? true : false}
            size="small"
            variant="text"
            style={{ fontFamily: "Tenorite" }}
            onClick={() => window.open(sourceCode)}
          >
            SOURCE CODE
          </Button>
        </CardActions>
      </div>
    </Card>
  );
};

export default ProjectCard;
